<template>
  <fieldset>
    <div class="row align-items-center">
      <label class="col-sm-3 control-label"> Gender* </label>
      <div class="col-sm-8">
        <dropdown-list
          v-model="data.gender"
          :options="genderList"
          required
        />
      </div>
    </div>

    <div class="row align-items-center">
      <label class="col-sm-3 control-label mt-2"> Has Own Wheelchair </label>
      <div class="col-sm-3">
        <el-checkbox
          id="hasOwnWheelchair"
          v-model="data.hasOwnWheelchair"
        >
          {{ data.hasOwnWheelchair ? 'Yes' : 'No' }}
        </el-checkbox>
      </div>
    </div>

    <div class="row align-items-center">
      <label class="col-sm-3 control-label"> Level of Services* </label>
      <div class="col-sm-8">
        <dropdown-list
          v-model="data.levelOfService"
          :options="stawavLevelOfServices"
          required
        />
      </div>
    </div>

    <div class="row">
      <label class="col-sm-3 control-label pt-5"> Special Instructions </label>
      <div class="col-sm-8">
        <sanitized-textarea
          v-model="data.specialInstructions"
          autosize
        />
      </div>
    </div>

    <div class="row align-items-center">
      <label class="col-sm-3 control-label"> Number of Companions/Ride along </label>
      <div class="col-sm-6">
        <number-input
          id="numberOfCompanions"
          v-model="data.numberOfCompanions"
          type="number"
          class="form-control"
          min="0"
          :is-decimal="false"
        />
      </div>
    </div>

    <div class="row align-items-center">
      <label class="col-sm-3 control-label"> Appointment Type* </label>
      <div class="col-sm-8">
        <sanitized-input
          v-model="data.appointmentType"
          required
          placeholder="Meeting"
          :disabled="isDisabledFields"
        />
      </div>
    </div>

    <div class="row align-items-center">
      <label class="col-sm-3 control-label"> Appointment Time* </label>
      <div class="col-sm-8">
        <time-picker
          v-model="data.appointmentTime"
          clearable
          class="mt-5"
          required
          format="hh:mm a"
          :disabled="isDisabledFields"
        />
      </div>
    </div>

    <ChooseScheduledRideType
      v-model="scheduleKind"
      :disabled="isDisabledFields"
      :appointment-allowed="false"
      :willcall-allowed="false"
    />

    <repeat-ride-data
      v-if="isRepeatedRide"
      :data="data"
      :is-show-time-warning-message="isShowTimeWarningMessage"
      :disabled-date="disabledDate"
      @change-pickup-time="$emit('change-pickup-time')"
    />

    <single-ride-data
      v-else
      :data="data"
      :is-show-time-warning-message="isShowTimeWarningMessage"
      :disabled-date="disabledDate"
      @change-pickup-time="$emit('change-pickup-time')"
    />

    <div class="row align-items-center">
      <label class="col-sm-3 control-label"> Return Time </label>
      <div class="col-sm-8">
        <time-picker
          v-model="data.returnTime"
          clearable
          format="hh:mm a"
          :disabled="isDisabledFields"
        />
      </div>
    </div>

    <div class="row align-items-center">
      <label class="col-sm-3 control-label"> Stairs at Pickup Location </label>
      <div class="col-sm-8">
        <number-input
          id="stairStepsForPU"
          v-model="data.stairStepsForPU"
          type="number"
          class="form-control"
          min="0"
          :is-decimal="false"
        />
      </div>
    </div>

    <div class="row align-items-center">
      <label class="col-sm-3 control-label"> Stairs at Dropoff Location </label>
      <div class="col-sm-8">
        <number-input
          id="stairStepsForDO"
          v-model="data.stairStepsForDO"
          type="number"
          class="form-control"
          min="0"
          :is-decimal="false"
        />
      </div>
    </div>

    <div class="row align-items-center">
      <label class="col-sm-3 control-label"> DropOff Phone Number </label>
      <phone-number-input
        v-model="data.dropOffPhoneNumber"
        class="col-sm-8"
      />
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent, ref, watch } from 'vue';

import { genderList } from '@/constants/app';
import { stawavLevelOfServices } from '@/constants/ride';

const ChooseScheduledRideType = defineAsyncComponent(() => import('./ChooseScheduledRideType.vue') as any);

const RepeatRideData = defineAsyncComponent(() => import('./RepeatRideData.vue') as any);

const SingleRideData = defineAsyncComponent(() => import('./SingleRideData.vue') as any);

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },

  disabledDate: {
    type: Function,
    default: () => null,
  },

  isDisabledFields: {
    type: Boolean,
    default: false,
  },

  isShowTimeWarningMessage: {
    type: Boolean,
    default: false,
  },
});

const scheduleKind = ref<string>('single');
watch(scheduleKind, (v) => {
  switch (v) {
    case 'multi':
      return props.data.rideMultiple = true;
    default:
      return props.data.rideMultiple = false;
  }
})

defineEmits(['change-pickup-time']);

const isRepeatedRide = computed(() => props.data.rideMultiple);
</script>
